import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import NewSidebar from "../Layout/NewSidebar";
import NewHeader from "../Layout/NewHeader";
import { useDispatch, useSelector } from "react-redux";
import { data, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { allapiAction } from "../../Redux/common/action";
import { Col, Input, Modal, Row } from "antd";
import imageCompression from "browser-image-compression";
import { useRef } from "react";
import Webcam from "react-webcam";
import Select from "react-select";
import ImageUploading from "react-images-uploading";
import { URL } from "../../Redux/common/url";
import HomeSlider from "./HomeSlider";
const Dashboard = () => {
  const toggleSidebar = () => {
    document.body.classList.toggle("collapsed");
  };

  const copyReferral = () => {
    navigator.clipboard.writeText(
      "https://yourdomain.com/referral/ORA834326437"
    );
    alert("Referral link copied!");
  };
  const [value, setValue] = useState("");
  const [valuevendor, setValuevendor] = useState("");
  const [valuesetUserDeatils, setUserDeatils] = useState({});

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const maxNumber = 1;

  useEffect(() => {
    if (typeof window !== "undefined") {
      setValue(localStorage.getItem("access_token"));
      setValuevendor(localStorage.getItem("access_token_vendor"));

      const userDetails = localStorage.getItem("access_user");

      setUserDeatils(JSON?.parse(userDetails));
    } else {
      setValue("");
      setValuevendor("");
      setUserDeatils({});
    }
  }, []);

  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [error, setError] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [subList, setsubList] = useState([]);
  useEffect(() => {
    getLocation();
      dispatch(allapiAction.getsliderList({ page: "home" }));
    return () => {};
  }, []);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          setError(error.message);
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
    }
  };

  const [statusDataBox, setstatusDataBox] = useState(false);
  const [statusDataBox2, setstatusDataBox2] = useState(false);
  const [statusDataBox1, setstatusDataBox1] = useState(false);

  const [statusData, setstatusData] = useState({});

  const hendleToupdatepro = async () => {
    // edituserProfileByuser

    if (!imagesPro[0]?.file) {
      toast.error("please select profile");
      return;
    }
    const data = new FormData();
    // data.append("branch_name", userKycEdit?.branch_name);
    // data.append("bank_name", userKycEdit?.bank_name);
    // data.append("acc_no", userKycEdit?.acc_no);
    // data.append("ifsc", userKycEdit?.ifsc);
    // data.append("_id", userKycEdit?._id);
    if (imagesPro[0]?.file) {
      // roledata?.role_name
      // data.append("profile_image", imagesPro[0]?.file);
      data.append("logo", imagesPro[0]?.newfile, imagesPro[0]?.file?.name);
    }
    await dispatch(allapiAction.updateBussLogo(data));
    dispatch(allapiAction.getprofile({}));
    setstatusDataBox2(false);
  };

  const base64ToBlob = (base64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(base64Data.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const webcamRef = useRef(null);
  const [image, setImage] = useState(null);
  const [facingMode, setFacingMode] = useState("user");
  const flipCamera = () => {
    setFacingMode((prevState) =>
      prevState === "user" ? "environment" : "user"
    );
  };
  const videoConstraints = {
    facingMode: facingMode, // कैमरा फ्रंट या बैक चुनने के लिए
  };
  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
  };

  const [imagesPro, setImagesPro] = React.useState([]);

  const onChangePro = async (imageList, addUpdateIndex) => {
    // data for submit
    if (imageList.length > 0) {
      const options = {
        maxSizeMB: 1, // Max 1MB
        maxWidthOrHeight: 800, // Max width/height
        useWebWorker: true, // Faster processing
      };
      const compressedFile = await imageCompression(
        imageList[0]?.file,
        options
      );
      imageList[0].newfile = compressedFile;
    }
    setImagesPro(imageList);
  };
  const hendletoCompleteSubmitOrder = async () => {
    //

    const blob = base64ToBlob(image, "image/jpeg");

    console.log(blob);
    // const options = {
    //   maxSizeMB: 1, // Max 1MB
    //   maxWidthOrHeight: 800, // Max width/height
    //   useWebWorker: true, // Faster processing
    // };
    // const compressedFile = await imageCompression(blob, options);
    // console.log(compressedFile);

    // return;
    if (latitude == "") {
      toast?.error("please allow location");
      return;
    }
    // if (!userselete2) {
    //   toast?.error("please select user");
    //   return;
    // }
    if (!statusData?.discription) {
      toast?.error("please discription");
      return;
    }
    const formData = new FormData();
    formData.append("image", blob, "photo.jpg");
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    formData.append("discription", statusData?.discription);
    formData.append("type", statusData?.type);
    formData.append("followupdate", statusData?.followupdate);
    formData.append("categoryId", selectedOption?._id);
    const userdeatisl = {
      discription: statusData?.discription,
      type: statusData?.type,

      // userIdnew: ,a

      latitude: latitude,
      longitude: longitude,
      // user_name: get_seller_all_list?.userDetails?.fullName,
    };
    // if (userselete2?._id) {
    //   userdeatisl.userIdnew = userselete2?._id;
    // }
    // if (ListParty?.length > 0 && statusData?.type == "Plan") {
    //   const resp = ListParty?.map((item) => {
    //     return {
    //       party: {
    //         _id: item?.party?._id,
    //         fullName: item?.party?.displayName,
    //         referId: item?.party?.referId,
    //         phone: item?.party?.phone,
    //       },
    //       discription: item?.discription,
    //     };
    //   });
    //   userdeatisl.discriptionpartyWise = JSON.stringify(resp);
    // }
    const response = await dispatch(allapiAction.visitAndPlan(formData));
    if (response?.success) {
      setstatusDataBox1(false);
      setstatusDataBox(false);
      // navigate("/account-sales-man");
      // setfirst(response?.data);
      // setproductName("");
      // setsaledata({ amount: 0, commission: 0 });
    }
  };

  console.log("subList", subList);
  const deshboard = useSelector((state) =>
    state?.allapi?.deshboard ? state?.allapi?.deshboard : {}
  );
  const get_profile = useSelector((state) =>
    state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
  );
  const all_categories_List = useSelector((state) =>
    state?.allapi?.all_categories_List ? state?.allapi?.all_categories_List : {}
  );

  useEffect(() => {
    if (get_profile?.sellerProfile) {
      setImagesPro([
        { data_url: URL.API_BASE_URL + get_profile?.sellerProfile },
      ]);
    }
    return () => {};
  }, [get_profile]);
  console.log("all_categories_List", all_categories_List);
  useEffect(() => {
    // dispatch(allapiAction.vendordeshBoradData({}));
    // dispatch(allapiAction.categoryWiseSale({}));
    dispatch(allapiAction.deshBoradDataUserData());
    dispatch(allapiAction.getprofile());
    dispatch(allapiAction.getCategory());

    return () => {};
  }, []);
  useEffect(() => {
    const dropList = all_categories_List?.map((data, i) => {
      data.value = data?._id;
      data.label = data?.name;

      return data;
    });

    setsubList(dropList);
  }, [all_categories_List]);
  let pageUrl =
    "https://gatewaylandmarkgroup.com/referalsignup?ref=" + get_profile?.referId;

  function copy() {
    const el = document.createElement("input");
    el.value = pageUrl;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    // setCopied(true);
    toast.success("Your Referal link Copied!");

    // setstshareshow(false);
  }
  const hendleTochangedata = (e) => {
    const { name, value } = e.target;

    setstatusData({ ...statusData, [name]: value });
  };
  const [userData, setuserData] = useState({});
  const hendleToViewM = (e) => {
    setstatusDataBox(true);
    setuserData(e);
  };

  return (
    <>
      <NewHeader />
      <NewSidebar />

      <div className="main" id="main" style={{ paddingBottom: "50px" }}>
        <Modal
          title="Add Report"
          centered
          open={statusDataBox}
          onOk={() => hendletoCompleteSubmitOrder(false)}
          onCancel={() => setstatusDataBox(false)}
          width={500}
        >
          <div>
            <Row>
              <Col span={24}>Select plan </Col>
              <Col span={24}>
                {/* <Input
                name="discription"
                placeholder="enter discription"
                value={statusData?.discription}
                onChange={(e) => {
                  hendleTochangedata(e);
                }}
              /> */}

                <select
                  className="form-control"
                  onChange={(e) => hendleTochangedata(e)}
                  name="type"
                >
                  <option value={""}>Select </option>
                  <option value={"Plan"}>Plan</option>
                  {/* <option value={"Collect Payment"}>Collect Payment</option>
                  <option value={"Order"}>Order</option> */}
                  <option value={"Visit"}>Visit</option>
                  {/* <option value={"New Distributor"}>New Distributor</option>
                  <option value={"Visit Distributor"}>Visit Distributor</option>
                  <option value={"Report"}>Report </option> */}
                  <option value={"Others"}>Others </option>
                </select>
              </Col>

              <Col span={24}>Discription</Col>
              <Col span={24}>
                <Input
                  name="discription"
                  placeholder="enter discription"
                  value={statusData?.discription}
                  onChange={(e) => {
                    hendleTochangedata(e);
                  }}
                />
              </Col>
              <Col span={24}>Follow up Date</Col>
              <Col span={24}>
                <input
                  name="followupdate"
                  className="form-control"
                  type="date"
                  placeholder="enter followupdate"
                  value={statusData?.followupdate}
                  onChange={(e) => {
                    hendleTochangedata(e);
                  }}
                />
              </Col>
              <Col span={24}>Scheme Name</Col>
              <Col span={24}>
                <Select
                  defaultValue={selectedOption}
                  onChange={setSelectedOption}
                  options={subList}
                />
              </Col>
              <Col span={24}>Photo</Col>
              <Col span={24}>
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  width={320}
                  height={240}
                  videoConstraints={videoConstraints}
                />
                <div>
                  <button onClick={flipCamera} className=" btn btn-info">
                    {facingMode === "user"
                      ? "Switch to Back Camera"
                      : "Switch to Front Camera"}
                  </button>
                  <button onClick={capture} className="ml-3 btn btn-primary">
                    Capture photo
                  </button>
                  {/* <button onClick={hendletotest}>Capture photo</button> */}
                  {image && (
                    <>
                      <img src={image} alt="Captured" className="mt-5" />
                      {/* <button onClick={uploadImage}>Upload Photo</button> */}
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Modal>
        <Modal
          title="Profile Change"
          centered
          open={statusDataBox2}
          onOk={() => hendleToupdatepro(false)}
          onCancel={() => setstatusDataBox2(false)}
          width={500}
        >
          <div>
            <Row>
              <Col span={24}>Select plan </Col>
              <Col span={24}>
                <ImageUploading
                  // multiple
                  value={imagesPro}
                  onChange={onChangePro}
                  maxNumber={maxNumber}
                  dataURLKey="data_url"
                  acceptType={["png", "jpeg", "jpg", "webp"]}
                >
                  {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    onImageRemove,
                    isDragging,
                    dragProps,
                  }) => (
                    // write your building UI
                    <div className="upload__image-wrapper">
                      <button
                        className="btn btn-primary btn-sm rounded"
                        style={isDragging ? { color: "red" } : undefined}
                        onClick={onImageUpload}
                        {...dragProps}
                      >
                        Click or Drop here
                      </button>
                      &nbsp;
                      {imageList.map((image, index) => (
                        <div key={index} className="image-item">
                          <img src={image["data_url"]} alt="" width="100" />
                          <div className="image-item__btn-wrapper">
                            <button
                              className="btn btn-primary btn-sm rounded mb-2"
                              onClick={() => onImageUpdate(index)}
                            >
                              Update
                            </button>
                            <button
                              className="btn btn-primary btn-sm rounded"
                              onClick={() => onImageRemove(index)}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </ImageUploading>
              </Col>
            </Row>
          </div>
        </Modal>

        <div className="row">
          <div className="col-md-6 col-sm-12">
            <div className="profile-card">
              <div id="avatar">
                <img
                  // style={{width:"100%"}}
                  src={
                    get_profile?.sellerProfile
                      ? URL?.API_BASE_URL + get_profile?.sellerProfile
                      : "https://r2.erweima.ai/imgcompressed/img/compressed_0bf14e00cfcb51fab531dda39f371848.webp"
                  }
                  onError={(e) => {
                    e.target.src =
                      "https://r2.erweima.ai/imgcompressed/img/compressed_0bf14e00cfcb51fab531dda39f371848.webp";
                  }}
                />
                <button
                  className="proeditbtn"
                  onClick={() => {
                    setstatusDataBox2(true);
                  }}
                >
                  {/* <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i> */}
                  <i class="fa-solid fa-pen-to-square"></i>
                  {/* Edit */}
                </button>
              </div>
              {/* <img
                src="https://r2.erweima.ai/imgcompressed/img/compressed_0bf14e00cfcb51fab531dda39f371848.webp" // yahan user ki profile image ka URL lagayein
                alt="User Profile"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              /> */}
              <p className="mt-3 mb-1">
                <strong>UID:</strong>{" "}
                {get_profile?.referId ? get_profile?.referId : "******"}
              </p>
              <p className="mb-1">
                <strong>Name:</strong>{" "}
                {get_profile?.fullName ? get_profile?.fullName : "******"}
              </p>
              <p className="mb-1">
                <strong>Email:</strong>{" "}
                {get_profile?.email ? get_profile?.email : "******"}
              </p>
              <p className="mb-1">
                <strong>Phone:</strong>{" "}
                {get_profile?.number ? get_profile?.number : "******"}
              </p>
              <p className="mb-2">
                <strong>Referral Program:</strong>{" "}
                {get_profile?.status ? get_profile?.status : "******"}
              </p>
              <button className="copy-btn" onClick={copy}>
                Copy Referral Link
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  hendleToViewM();
                }}
              >
                Add Report And Plans
              </button>
            </div>
          </div>

          <div className="col-md-6 col-sm-12">
            <div className="slider vsslider">
              {/* <img
                src="https://vishwakarmalifespaces.com/wp-content/uploads/2020/06/h2-prop-slider-4.jpg"
                alt="Slider"
              /> */}
              <HomeSlider/>
            </div>
          </div>
        </div>

        <div className="marquee-wrapper">
          <marquee
            behavior="scroll"
            direction="left"
            scrollamount="6"
            style={{
              backgroundColor: "#1c0f5c",
              color: "#fff",
              padding: "10px 0",
              borderRadius: "5px",
            }}
          >
            🎉 Welcome to   Gatway Landmark GroupDashboard! Check your Income, Team, and
            Bonuses here! 🎉
          </marquee>
        </div>

        <div className="row info-cards">
          <div className="col-md-3 col-6">
            <div
              className="card-box"
              style={{ background: "#f39c12", color: "#fff" }}
            >
              {deshboard?.DirectTeam ? deshboard?.DirectTeam : 0}
              <br />
              Direct Team
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div
              className="card-box"
              style={{ background: "#e74c3c", color: "#fff" }}
            >
              {deshboard?.allTeam ? deshboard?.allTeam : 0}
              <br />
              Total Team
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div
              className="card-box"
              style={{ background: "#3498db", color: "#fff" }}
            >
              {" "}
              {get_profile?.point ? get_profile?.point?.toFixed(2) : 0} <br />
              Total Income
            </div>
          </div>
          <div
            className="col-md-3 col-6"
            onClick={() => navigate("/level-income")}
          >
            <div
              className="card-box"
              style={{ background: "#1abc9c", color: "#fff" }}
            >
              {get_profile?.levelIncome
                ? get_profile?.levelIncome?.toFixed(4)
                : 0}{" "}
              <br />
         Withdrawal Bonus
              {/* Level Income */}
            </div>
          </div>
        </div>
        <div className="row info-cards">
          <div
            className="col-md-3 col-6"
            onClick={() => navigate("/direct-income")}
          >
            <div
              className="card-box"
              style={{ background: "#f39c12", color: "#fff" }}
            >
              {get_profile?.levelIncomedm
                ? get_profile?.levelIncomedm?.toFixed(2)
                : 0}
              <br />
             Booking Bonus
            </div>
          </div>
          {/* <div className="col-md-3 col-6">
            <div
              className="card-box"
              style={{ background: "#e74c3c", color: "#fff" }}
            >
              {get_profile?.tureIncome
                ? get_profile?.tureIncome?.toFixed(2)
                : 0}
              <br />
              Tour Achievment Income
            </div>
          </div> */}
          <div
            className="col-md-3 col-6"
            onClick={() => navigate("/visit-site")}
          >
            <div
              className="card-box"
              style={{ background: "#3498db", color: "#fff" }}
            >
              <br />
              Visit history
            </div>
          </div>
        </div>

        <br />
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </div>

      <style jsx="true">{`
        body {
          margin: 0;
          font-family: "Poppins", sans-serif;
          background: #f5f5f5;
        }
        .sidebar {
          height: 100vh;
          width: 250px;
          position: fixed;
          top: 0;
          left: 0;
          background-color: #1c0f5c;
          padding-top: 70px;
          transition: all 0.3s;
          overflow-y: auto;
        }
        .sidebar a {
          padding: 15px 20px;
          text-decoration: none;
          font-size: 18px;
          color: #fff;
          display: block;
          transition: 0.3s;
        }
        .sidebar a:hover {
          background-color: #2d1b80;
        }
        .header {
          background-color: #1c0f5c;
          height: 60px;
          width: 100%;
          position: fixed;
          top: 0;
          left: 0;
          z-index: 999;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          color: #fff;
        }
        .toggle-btn {
          font-size: 24px;
          cursor: pointer;
          color: #fff;
        }
        .main {
          margin-left: 250px;
          padding: 80px 20px 20px 20px;
          transition: all 0.3s;
        }
        .collapsed .sidebar {
          width: 0;
        }
        .collapsed .main {
          margin-left: 0;
        }
        .profile-card {
          background: radial-gradient(
            ellipse at center,
            #b5e2e5 0,
            #49c8d1 100%
          );
          padding: 20px;
          border-radius: 15px;
          //   margin-top: 20px;
          margin-bottom: 20px;
          text-align: center;
        }
        .copy-btn {
          background: linear-gradient(45deg, #3498db, #1abc9c);
          color: #fff;
          border: none;
          margin-top: 10px;
          padding: 8px 20px;
          border-radius: 20px;
          font-size: 14px;
          cursor: pointer;
          transition: background 0.3s;
        }
        .copy-btn:hover {
          background: linear-gradient(45deg, #1abc9c, #3498db);
        }
        .slider {
          margin-bottom: 20px;
        }
        .slider img {
          width: 100%;
          {/* height: 250px; */}
          object-fit: cover;
          border-radius: 10px;
        }
        .info-cards {
          margin-top: 20px;
        }
        .card-box {
          background: #fff;
          padding: 20px;
          border-radius: 15px;
          text-align: center;
          box-shadow: 0 5px 25px rgba(41, 128, 185, 0.15);
          margin-bottom: 20px;
          height: 100px; /* fixed height */
          overflow: hidden; /* hides overflow */
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-size: 14px; /* smaller font for long content */
          line-height: 1.2;
          word-break: break-word; /* force wrap long words */
        }

        .marquee-wrapper {
          margin: 20px 0;
          font-weight: bold;
          color: #1c0f5c;
          font-size: 18px;
        }
        @media (min-width: 992px) {
          .sidebar {
            position: fixed;
            top: 0;
            left: 0;
          }
          .main {
            margin-left: 250px;
          }
        }
      `}</style>
    </>
  );
};

export default Dashboard;
